import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-picker-legacy.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlPickerLegacy = /*@__PURE__*/ createInlineOverlayComponent<
  JSX.FmlPickerLegacy,
  HTMLFmlPickerLegacyElement
>('fml-picker-legacy', defineCustomElement);
